/* eslint-disable no-unused-vars */

function homeHero() {

    const moduleWrappers = document.querySelectorAll('.homeHero__stats');

    moduleWrappers.forEach((moduleWrapper) => {

        const statItems = moduleWrapper.querySelectorAll(".homeHero__statItem");
        let currentStatIndex = 0;

        function crossfadeStats() {
            statItems.forEach(item => item.classList.remove("active"));
            statItems[currentStatIndex].classList.add("active");

            // Increment the index for the next stat item
            currentStatIndex = (currentStatIndex + 1) % statItems.length;

            // if moduleWrapper has class homeHero__stats--alt, set different timeout
            if ( moduleWrapper.classList.contains('homeHero__stats--alt') ) {
                setTimeout(crossfadeStats, 4000);
            } else {
                // Repeat the crossfade every 3 seconds (adjust as needed)
                setTimeout(crossfadeStats, 5000);
            }

        }

        // Start the crossfade loop
        crossfadeStats();

    });

    
};

const interactiveList = () => {

    // get id homeList__contentItem-1
    const item1 = document.getElementById('homeList__contentItem-1');
    // get item with aria-controls homeList__contentItem-1
    const item1Trigger = document.querySelector('[aria-controls="homeList__contentItem-1"]');
    //add class active to item1
    item1.classList.add('active');
    // set aria-expanded to true
    item1Trigger.setAttribute('aria-expanded', 'true');
    // add class active to item1Trigger
    item1Trigger.classList.add('active');

    // get all the triggers
    const triggers = document.querySelectorAll('.homeList__control');
    // loop through each trigger
    triggers.forEach((trigger) => {
        // on click of trigger
        trigger.addEventListener('click', () => {
            // get the id of the trigger
            const id = trigger.getAttribute('aria-controls');
            // get the item with the id
            const item = document.getElementById(id);
            // get the active item
            const activeItem = document.querySelector('.homeList__contentItem.active');
            // get the active trigger
            const activeTrigger = document.querySelector('.homeList__control[aria-expanded="true"]');
            // remove active class from active item
            activeItem.classList.remove('active');
            // remove active class from active trigger
            activeTrigger.classList.remove('active');
            // set aria-expanded to false
            activeTrigger.setAttribute('aria-expanded', 'false');
            // add active class to item
            item.classList.add('active');
            // add active class to trigger
            trigger.classList.add('active');
            // set aria-expanded to true
            trigger.setAttribute('aria-expanded', 'true');
        });
    });
}

/**
 * Function to run when this module is called from site.js
 */
const init = () => {

    if (document.querySelector('.page-template-template__home')) {
        homeHero();
        interactiveList();
    }
    
};

export default init;
